/** @file Quaternion composition: the Hamilton product. */
import type { Quat } from './quat';

/**
 * `a * b`: the rotation that applies b first, then a. With a = (u, s) and b = (v, t) (vector, scalar):
 * vector part `s v + t u + u x v`, scalar part `s t - u . v`.
 */
export function quatMul(a: Quat, b: Quat): Quat {
  const [ax, ay, az, aw] = a;
  const [bx, by, bz, bw] = b;
  return [
    aw * bx + bw * ax + (ay * bz - az * by),
    aw * by + bw * ay + (az * bx - ax * bz),
    aw * bz + bw * az + (ax * by - ay * bx),
    aw * bw - (ax * bx + ay * by + az * bz),
  ];
}
